import Vue from 'vue';

import Router from 'vue-router';
import Meta from 'vue-meta';

import Auth from './routes/auth.js';
import Error from './routes/error.js';
import TechnicalManagement from './routes/technical-management.js';

import { EventBus } from 'relapp-event';

Vue.use(Router);
Vue.use(Meta);

let router = new Router({
    mode: 'history',
    base: '/',
    routes: [...Auth, ...TechnicalManagement, ...Error]
});

EventBus.$on('route', route => {
    router.push(route);
});

export default router;
